<template>
  <img
    :src="$webDomain + '/' + data.mainImageType + '/' + data.mainImage"
    alt="not found"
  />
</template>

<script>
export default {
  props: ["data"],
};
</script>
